/**
 * Eventos internos (nomes do Event Mapping) que também vão ao dataLayer para as plataformas de
 * mídia (Meta e Google), via GTM. Fase 1 do plano de medição de Atração e Fidelização: P0 e P1,
 * os que impactam a conversão. As próximas fases (P2, P3) entram adicionando nomes aqui.
 *
 * `acessou_checkout` e `click_checkout_confirmar_acordo` são os equivalentes, no checkout novo,
 * de `click_divida` e `click_confirmar_acordo`, que o Event Mapping ainda lista mas que não
 * disparam mais.
 */
export const EVENTOS_MARKETING = [
  'confirmou_cpf',
  'acessou_portal',
  'click_em_login',
  'click_em_login_google',
  'click_em_cadastrar',
  'cadastro_google_finalizado',
  'autenticacao_completa',
  'acessou_checkout',
  'click_checkout_confirmar_acordo',
  'enviou_proposta',
  'acessou_pagina_pagamento',
  'click_baixar_boleto',
  'click_pagar_pix',
  'acessou_sucesso_pagamento_pix',
] as const;

export type EventoMarketing = (typeof EVENTOS_MARKETING)[number];

export const EVENTO_PAGEVIEW_VIRTUAL = 'virtual_pageview';

/**
 * Eventos do portal que viram eventos da Meta (direcionamento de Mídia Paga para o remarketing).
 * `Promessa` é personalizado e vai sem valor: valor da dívida é dado sensível.
 * `confirmou_cpf` é a "ativação" (CPF consultado com sucesso), não a visita ao login.
 */
export const EVENTOS_META = {
  [EVENTO_PAGEVIEW_VIRTUAL]: 'PageView',
  acessou_checkout: 'ViewContent',
  confirmou_cpf: 'CompleteRegistration',
  enviou_proposta: 'Promessa',
} as const satisfies Partial<Record<EventoMarketing | typeof EVENTO_PAGEVIEW_VIRTUAL, string>>;

export type EventoMeta = (typeof EVENTOS_META)[keyof typeof EVENTOS_META];

const eventosMarketing: ReadonlySet<string> = new Set(EVENTOS_MARKETING);
const eventosMeta: ReadonlyMap<string, EventoMeta> = new Map(Object.entries(EVENTOS_META));

export function isEventoMarketing(nome: string): nome is EventoMarketing {
  return eventosMarketing.has(nome);
}

export function obterEventoMeta(nome: string): EventoMeta | undefined {
  return eventosMeta.get(nome);
}
